import {
  APP_REGISTRY,
  canAccessWindow,
  type FilterAppsAccessContext,
} from "@/components/ui/os-layout/OsAppRegistry";

/** App ids the user may open — same module rule as the AniOS dock. */
export function listAccessibleAppIdsForFeContext(
  hasPermission: (module: string) => boolean,
  access?: FilterAppsAccessContext,
): string[] {
  return Object.keys(APP_REGISTRY)
    .filter((appId) => canAccessWindow(appId, hasPermission, access?.user, access?.modulePermissions))
    .sort();
}
